import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from './Icon';
const NOTICE_ICON = {
    info: 'info',
    accent: 'info',
    good: 'circle-check',
    warn: 'triangle-alert',
    danger: 'circle-alert',
};
/** Zustand, der bleibt — im Inhalt, mit Icon und weicher Fläche, nie mit Linksrand. */
export function Notice({ tone = 'info', title, children, action, icon }) {
    return (_jsxs("div", { className: "one-notice", "data-tone": tone === 'info' ? undefined : tone, role: tone === 'danger' ? 'alert' : 'status', children: [_jsx(Icon, { name: icon ?? NOTICE_ICON[tone] }), _jsxs("div", { className: "one-notice-body", children: [title && _jsx("div", { className: "one-notice-title", children: title }), children && _jsx("div", { className: "one-notice-text", children: children })] }), action] }));
}
export function EmptyState({ icon = 'inbox', title, children, action }) {
    return (_jsxs("div", { className: "one-empty", children: [_jsx(Icon, { name: icon }), _jsx("div", { className: "one-empty-title", children: title }), children && _jsx("div", { children: children }), action] }));
}
export function Progress({ value, tone = 'accent', label }) {
    const anteil = Math.max(0, Math.min(1, value));
    return (_jsx("div", { className: "one-progress", "data-tone": tone === 'accent' ? undefined : tone, role: "progressbar", "aria-label": label, "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": Math.round(anteil * 100), children: _jsx("span", { style: { width: `${anteil * 100}%` } }) }));
}
/** Platzhalter in der Größe der späteren Zeile. */
export function Skeleton({ width = '100%', height = 16, }) {
    return _jsx("div", { className: "one-skeleton", style: { width, height }, "aria-hidden": true });
}
